import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { fetchActiveAccounts } from "../../queries/bank/accountsQuery";
import { fetchCollectionCategories } from "../../queries/collections/collectionQuery";
import api from "../../utils/api";

class NewCollection extends React.Component {
  state = {
    error: {},
    name: "",
    isSubmitting: false,
    status: {
      label: "Active",
      value: true,
    },
    bankAccounts: [],
    collectionCategories: [],
  };

  componentDidMount = async () => {
    await this.getBankAccounts(true);
    await this.getCollectionCategories(true);

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });

    if (field === "channel") {
      this.getActiveBanks(true, e.value);
    }
  }

  getBankAccounts = async (isLoadingAccount) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingAccount });

      const bankAccounts = await fetchActiveAccounts(defaultLanguage, {
        listType: "dropdown",
        active: true,
      });

      this.setState({
        bankAccounts,
        isLoadingAccount: false,
      });
    } catch (error) {
      this.setState({ isLoadingAccount: false });
    }
  };

  getCollectionCategories = async (isLoadingCategories) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingCategories });

      const collectionCategories = await fetchCollectionCategories(
        defaultLanguage,
        {
          listType: "dropdown",
          active: true,
        }
      );

      this.setState({
        collectionCategories,
        isLoadingCategories: false,
      });
    } catch (error) {
      this.setState({ isLoadingCategories: false });
    }
  };

  validateForm() {
    let { error, name, bankAccount, category } = this.state;

    if (name === "") {
      error.name = language[this.props.defaultLanguage].name_required;
    }

    if (!bankAccount) {
      error.name = language[this.props.defaultLanguage].account_required;
    }

    if (!category) {
      error.category = language[this.props.defaultLanguage].category_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, name, status, bankAccount, category } = this.state;
    const { id } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/collection/till`,
        data: {
          name,
          collectionTillId: "",
          active: status.value,
          accountId: bankAccount.value,
          collectionTillCategoryId: category.value,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "aggregator_update_success"
                : "aggregator_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "aggregator_update_error"
                : "aggregator_add_error"
            ]
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Select
            options={this.state.bankAccounts}
            label={language[this.props.defaultLanguage].account}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.bankAccount}
            onChange={(e) => this.onChangeInput("bankAccount", e)}
            error={this.state.error.bankAccount}
            isLoading={this.state.isLoadingAccount}
          />
          <Input
            label={language[this.props.defaultLanguage].name}
            placeholder={language[this.props.defaultLanguage].name_placeholder}
            value={this.state.name}
            onChange={(e) => this.onChangeInput("name", e)}
            error={this.state.error.name}
          />
          <Select
            options={this.state.collectionCategories}
            label={language[this.props.defaultLanguage].category}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.category}
            onChange={(e) => this.onChangeInput("category", e)}
            error={this.state.error.category}
            isLoading={this.state.isLoadingCategories}
          />
          <Select
            options={[
              { label: "Active", value: "true" },
              { label: "Inactive", value: "false" },
            ]}
            label={language[this.props.defaultLanguage].status}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.status}
            onChange={(e) => this.onChangeInput("status", e)}
            error={this.state.error.status}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewCollection);
